import { AfterViewInit, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { Organization } from "../../../common/models/organization";
import { User } from "../../../common/models/user";
import { OrganizationRole } from "../../../common/models/organization-role";
import { ConfigProvider } from "../../../config-provider.service";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { UsersProvider } from "../../providers/users-provider";
import { DiscussionsProvider } from "../../../discussions/providers/discussions-provider";
import { OrganizationsProvider } from "../../../organizations/providers/organizations-provider";
import { NgForOf, NgIf } from "@angular/common";
import { MatTooltip } from "@angular/material/tooltip";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'users-user-profile-dialog',
  providers: [],
  styleUrls: ['./user-profile-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogContent,
    NgForOf,
    NgIf,
    MatTooltip,
    TranslateModule,
    MatIcon,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ],
  templateUrl: './user-profile-dialog.html'
})
export class UsersUserProfileDialogComponent implements AfterViewInit {
    public user: User = new User({});
    public organization: Organization = new Organization({});
    public roles: OrganizationRole[] = [];
    public userLinksData: any[] = [];
    constructor(
        public conf: ConfigProvider,
        public dialog: MatDialogRef<UsersUserProfileDialogComponent>,
        public utils: UtilsProvider,
        public currentUser: CurrentUser,
        private _translater: TranslateService,
        private _discussions: DiscussionsProvider,
        private organizationsProvider: OrganizationsProvider,
        private _users: UsersProvider,
        private _changeDetector: ChangeDetectorRef,
        private _router: Router,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {
        if (_data.user) {
            this.user = this._data.user;
            this.loadUserLinks();
        }
        if (_data.organization) {
            this.organization = _data.organization;

            if (_data.roles) {
                this.roles = _data.roles;
            } else {
                this.loadRoles();
            }
        }
    }

    public ngAfterViewInit() {

    }

    public onDiscussClicked(): void {
        this._discussions.startOneToOneDiscussion(this.user).subscribe({
          error: (error: any) => this.onError(error)
        })
    }

    private loadUserLinks(): void {
        this._users.getUserUserLinksData(this.user.id!, false).subscribe({
            next: (data: any) => {
                this.userLinksData = data;
            },
            error: (error: any) => this.onError(error)
        })
    }

    private loadRoles(): void {
      this.organizationsProvider.getOrganizationRoleByOrganizationMembership(this.user.id!).subscribe({
        next: (roles: OrganizationRole[]) => {
          this.roles = roles;
        },
        error: (error: any) => this.onError(error)
      });
    }

    private onError(error: any): void {
        console.error("users/components/user-profile-dialog", error);
    }
}
